import { makeStyles } from 'tss-react/mui';

const useStylesRequiredMark: MaterialUIStylesCallback = makeStyles()((theme: MainTheme): MaterialUIStyles => ({
  requiredMark: {
    color: `${theme.palette.error.main} !important`,
    '&:hover': {
      color: `${theme.palette.error.main} !important`,
    },
  },
}));

export default useStylesRequiredMark;
